import React from 'react';
import styled from 'styled-components';
import { Poppins } from 'src/common/Poppins';
import { CheckCircleSvg } from 'src/assets/dynamicSvg';

const Pill = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 52px;
  padding: 8px 16px 8px 12px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
`;

export const StatusPill: React.FC<{ label: string }> = ({ label }) => (
  <Pill>
    <CheckCircleSvg size={20} color="statusGreen" />
    <Poppins px={14} weight={600} color="statusGreen" css="text-transform: uppercase; white-space: nowrap;">
      {label}
    </Poppins>
  </Pill>
);
